import { advancedFilter as filter } from "./advanced-filter"
import { AdvancedFilterConfig } from "@/utils/advancedFilter/type"
import { WorkspaceTemplate } from "@/types/workspace"
import { structuredDates } from "./config"

export const advancedFilter = (config: AdvancedFilterConfig, list: WorkspaceTemplate[]) => filter(config, list)

export const possibleDateOptions = structuredDates
